import React from "react";

// Campo "Método" unificado: select con la lista del venue (que ya incluye
// Efectivo y Transferencia, ver utils/metodosPago.js) y, como respaldo si la
// lista viniera vacía, texto libre. Guarda el NOMBRE del método, igual que
// pagos y costos, para que Cuentas pueda agrupar por él.
const MetodoPagoField = ({
  value,
  onChange,
  metodosPago = [],
  className = "",
  placeholder = "Transferencia, efectivo…",
  vacio = "Sin método",
  disabled = false,
}) => {
  const lista = Array.isArray(metodosPago) ? metodosPago : [];
  // Un método guardado que ya no está en la lista se sigue mostrando, para
  // no borrarlo en silencio al editar.
  const faltante = value && !lista.some((m) => m.nombre === value) ? value : null;
  if (lista.length === 0) {
    return (
      <input
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={className}
        disabled={disabled}
      />
    );
  }
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      className={className}
      disabled={disabled}
    >
      <option value="">{vacio}</option>
      {faltante && <option value={faltante}>{faltante}</option>}
      {lista.map((m) => (
        <option key={m.id || m.nombre} value={m.nombre}>
          {m.nombre}
        </option>
      ))}
    </select>
  );
};

export default MetodoPagoField;
